import { render, staticRenderFns } from "./RenameLayoutModal.vue?vue&type=template&id=6a16f9f0&scoped=true"
import script from "./RenameLayoutModal.vue?vue&type=script&lang=js"
export * from "./RenameLayoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a16f9f0",
  null
  
)

export default component.exports